import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/shielded-logo.png")